import { Select } from '@hubertai/hubert-component-library';
import { InterviewPropertySelectList } from './InterviewPropertySelect.constants';

interface Props {
  onSelect: (property: string) => void;
  selected: string;
  disabled?: boolean;
}

const InterviewPropertySelect = ({ onSelect, selected, disabled }: Props) => (
  <Select.Root value={selected || undefined} onValueChange={onSelect} disabled={disabled}>
    <Select.Trigger placeholder="Select property" aria-label="Interview property" />
    <Select.Content>
      {InterviewPropertySelectList.map((item) => (
        <Select.Item key={item.value} value={item.value}>
          {item.label}
        </Select.Item>
      ))}
    </Select.Content>
  </Select.Root>
);

export default InterviewPropertySelect;
